//Unique keys for every api call to distinguish every api url & its action.
export const API_ROUTES_KEY = {
  CHANGE_SUPPLIER_EMAIL: "CHANGE_SUPPLIER_EMAIL",
  RECEIVE_PURCHASE_ORDER: "RECEIVE_PURCHASE_ORDER",
  RECEIVE_STORE_RETURN_ORDER: "RECEIVE_STORE_RETURN_ORDER",
  EXECUTE_MATERIAL_TRANSFER: "EXECUTE_MATERIAL_TRANSFER",
  EXECUTE_INTRANSIT_MATERIAL_TRANSFER: "EXECUTE_INTRANSIT_MATERIAL_TRANSFER",
  RECEIVE_VM_RETURN_ORDER: "RECEIVE_VM_RETURN_ORDER",
  EXECUTE_REQUEST_ORDER: "EXECUTE_REQUEST_ORDER",
  DELETE_VM_REFILLS: "DELETE_VM_REFILLS",
  EXECUTE_SUPPLIER_RETURN: "EXECUTE_SUPPLIER_RETURN",
  DELETE_SUPPLIER_RETURN: "DELETE_SUPPLIER_RETURN",
  GET_ACKNOWLEDGE_REFILL: "GET_ACKNOWLEDGE_REFILL",
  GET_TALLY_INVENTORY: "GET_TALLY_INVENTORY",
  GET_TALLY_ORDER: "GET_TALLY_ORDER",
  USER_FILTER_PARAMETERS: " USER_FILTER_PARAMETERS",
  WAREHOUSE_FILTER_PARAMETERS: " WAREHOUSE_FILTER_PARAMETERS",
  DELETE_STORE_RETURN_ORDER: "DELETE_STORE_RETURN_ORDER",
  STORE_STORE_RETURN_ORDER: "STORE_STORE_RETURN_ORDER",
  PRODUCT_BRAND_LIST_FOR_FILTER: "PRODUCT_BRAND_LIST_FOR_FILTER",
  PRODUCT_CATEGORY_LIST_FOR_FILTER: "PRODUCT_CATEGORY_LIST_FOR_FILTER",
  ORDER_LIST_BY_ORDER_ID: "ORDER_LIST_BY_ORDER_ID",
  EDIT_VENDING_MACHINE: "EDIT_VENDING_MACHINE",
  LINK_HARDWARE_BOARD: "LINK_HARDWARE_BOARD",
  CHANGE_MULTIPLE_TEMPLATE: "CHANGE_MULTIPLE_TEMPLATE",
  GET_VM_LIST_BY_PLANOGRAM: "GET_VM_LIST_BY_PLANOGRAM",
  GET_PLANOGRAM_LIST_BY_VM_TEMPLATE: "GET_PLANOGRAM_LIST_BY_VM_TEMPLATE",
  GET_VM_LIST_BY_HARDWARE_BOARD: "GET_VM_LIST_BY_HARDWARE_BOARD",
  ISSUE_REPORTER: "ISSUE_REPORTER",
  LIST_ZONES: "LIST_ZONES",
  LIST_WAREHOUSES: "LIST_WAREHOUSES",
  WAREHOUSES_ORDERS_LIST: "WAREHOUSES_ORDERS_LIST",
  LIST_PARAMETERS_WAREHOUSES: "LIST_PARAMETERS_WAREHOUSES",
  LIST_PARAMETERS_TECHNICIAN: "LIST_PARAMETERS_TECHNICIAN",
  LIST_PARAMETERS_WAREHOUSE_STOCK: "LIST_PARAMETERS_WAREHOUSE_STOCK",
  LIST_PARAMETERS_WAREHOUSE_ORDERS: "LIST_PARAMETERS_WAREHOUSE_ORDERS",
  LIST_SHIPPING_WAREHOUSES: "LIST_SHIPPING_WAREHOUSES",
  GET_VENDING_MACHINE: "GET_VENDING_MACHINE",
  GET_STORE_INVENTORY: "GET_STORE_INVENTORY",
  GET_WAREHOUSE_INVENTORY: "GET_WAREHOUSE_INVENTORY",
  GET_WAREHOUSE_LIST: "GET_WAREHOUSE_LIST",
  GET_LITE_WAREHOUSE_LIST: "GET_LITE_WAREHOUSE_LIST",
  GET_VEHICLE_LIST: "GET_VEHICLE_LIST",
  CREATE_SAVED_REPORT: "CREATE_SAVED_REPORT",
  GET_SAVED_SALES_TEMPLATE: "GET_SAVED_SALES_TEMPLATE_LISTS",
  GET_SAVED_SALES_REPORT: "GET_SAVED_SALES_REPORT",
  GET_DEFAULT_SALES_TEMPLATE: "GET_DEFAULT_SALES_TEMPLATE",
  GET_USER_PRODUCT_CATEGORY_LIST: "GET_USER_PRODUCT_CATEGORY_LIST",
  DOWNLOAD_TRANSACTIONS_HISTORY: "DOWNLOAD_TRANSACTIONS_HISTORY",
  DOWNLOAD_FEEDBACK_HISTORY: "DOWNLOAD_FEEDBACK_HISTORY",
  GET_SUPPLIER_LIST: "GET_SUPPLIER_LIST",
  CREATE_SUPPLIER: "CREATE_SUPPLIER",
  CREATE_TALLY_INVENTORY_ORDER: "CREATE_TALLY_INVENTORY_ORDER",
  UPDATE_SUPPLIER: "UPDATE_SUPPLIER",
  GET_SUPPLIER: "GET_SUPPLIER",
  DELETE_SUPPLIER: "DELETE_SUPPLIER",
  GET_PRODUCT_LIST: "GET_PRODUCT_LIST",
  GET_PRODUCT_UNIT_LIST: "GET_PRODUCT_UNIT_LIST",
  GET_PRODUCT_BRAND_LIST: "GET_PRODUCT_BRAND_LIST",
  LIST_DS1_BRANDS: "LIST_DS1_BRANDS",
  LIST_DS1_PRODUCT_CATALOGUES: "LIST_DS1_PRODUCT_CATALOGUES",
  LIST_DS1_PRODUCTS_BY_CATALOGUE: "LIST_DS1_PRODUCTS_BY_CATALOGUE",
  GET_DS1_PRODUCT_FILTERS: "GET_DS1_PRODUCT_FILTERS",
  SYNC_DS1_PRODUCTS: "SYNC_DS1_PRODUCTS",
  LIST_DS1_ALL_PRODUCTS: "LIST_DS1_ALL_PRODUCTS",
  GET_DS1_ALL_PRODUCT_FILTERS: "GET_DS1_ALL_PRODUCT_FILTERS",
  GET_DS1_PRODUCT_VARIANT_OVERVIEW: "GET_DS1_PRODUCT_VARIANT_OVERVIEW",
  ARCHIVE_DS1_PRODUCT_VARIANT: "ARCHIVE_DS1_PRODUCT_VARIANT",
  SYNC_DS1_FULL_CATALOGUE: "SYNC_DS1_FULL_CATALOGUE",
  GET_TALLY_INVENTORY_CATEGORY_LIST: "GET_TALLY_INVENTORY_CATEGORY_LIST",
  GET_TALLY_INVENTORY_BRAND_LIST: "GET_TALLY_INVENTORY_BRAND_LIST",
  GET_PRODUCT_PACKAGING_LIST: "GET_PRODUCT_PACKAGING_LIST",
  GET_PRODUCT_SHELF_LIFE_LIST: "GET_PRODUCT_SHELF_LIFE_LIST",
  GET_PRODUCT_STATUS_LIST: "GET_PRODUCT_STATUS_LIST",
  GET_PRODUCT_TYPE_LIST: "GET_PRODUCT_TYPE_LIST",
  GET_PURCHASE_ORDER_LIST: "GET_PURCHASE_ORDER_LIST",
  CREATE_PURCHASE_ORDER: "CREATE_PURCHASE_ORDER",
  GET_PURCHASE_ORDER: "GET_PURCHASE_ORDER",
  DELETE_PURCHASE_ORDER: "DELETE_PURCHASE_ORDER",
  UPDATE_PURCHASE_ORDER: "UPDATE_PURCHASE_ORDER",
  MANAGE_PURCHASE_ORDER: "MANAGE_PURCHASE_ORDER",
  GET_SUPPLIER_LIST_BY_PRODUCT_IDS: "GET_SUPPLIER_LIST_BY_PRODUCT_IDS",
  GET_PRICE_AND_QUANTITY_BY_SUPPLIER: "GET_PRICE_AND_QUANTITY_BY_SUPPLIER",
  // list active and discontinued products of inventory
  GET_COMPANY_INVENTORY_ACTIVE_PRODUCTS:
    "GET_COMPANY_INVENTORY_ACTIVE_PRODUCTS",
  GET_COMPANY_INVENTORY_MAPPED_WITH_SUPPLIERS:
    "GET_COMPANY_INVENTORY_MAPPED_WITH_SUPPLIERS",
  // list active and disconinued products of store inventory
  GET_STORE_INVENTORY_ACTIVE_PRODUCTS: "GET_STORE_INVENTORY_ACTIVE_PRODUCTS",
  UPDATE_RUNOUT_AND_MAX_QTY: "UPDATE_RUNOUT_AND_MAX_QTY",
  LIST_STORE_AND_WAREHOUSE_INVENTORY: "LIST_STORE_AND_WAREHOUSE_INVENTORY",
  GET_STORE_MANAGER: "GET_STORE_MANAGER",
  CREATE_STORE_MANAGER: "CREATE_STORE_MANAGER",
  UPDATE_STORE_MANAGER: "EDIT_STORE_MANAGER",
  DELETE_STORE_MANAGER: "DELETE_STORE_MANAGER",
  GET_STORE_MANAGER_LIST: "GET_STORE_MANAGER_LIST",
  GET_STORE: "GET_STORE",
  GET_BULK_REFILL_LIST: "GET_BULK_REFILL_LIST",
  GET_BULK_REFILL: "GET_BULK_REFILL",
  DELETE_BULK_REFILL: "DELETE_BULK_REFILL",
  CREATE_BULK_REFILL: "CREATE_BULK_REFILL",
  UPDATE_BULK_REFILL: "UPDATE_BULK_REFILL ",
  GET_STORE_MANAGER_BY_STORE_ID: "GET_STORE_MANAGER_BY_STORE_ID",
  GET_VM_TEMPLATE_LIST: "GET_VM_TEMPLATE_LIST",
  GET_VM_TEMPLATE_NAME_LIST: "GET_VM_TEMPLATE_NAME_LIST",
  GET_VM_TEMPLATE: "GET_VM_TEMPLATE",
  DELETE_VM_TEMPLATE: "DELETE_VM_TEMPLATE",
  CREATE_VM_TEMPLATE: "CREATE_VM_TEMPLATE",
  UPDATE_VM_TEMPLATE: "UPDATE_VM_TEMPLATE",
  CREATE_REFILL: "CREATE_REFILL",
  UPDATE_REFILL: "UPDATE_REFILL",
  ASSIGN_DP_TO_REFILL_IN_BULK_REFILL: "ASSIGN_DP_TO_REFILL_IN_BULK_REFILL",
  GET_DELIVERY_PERSON_LIST: "GET_DELIVERY_PERSON_LIST",
  GET_REFILL_PARTNER_LIST: "GET_REFILL_PARTNER_LIST",
  GET_TECHNICIAN_PARTNER_LIST: "GET_TECHNICIAN_PARTNER_LIST",
  GET_INCIDENT_LIST: "GET_INCIDENT_LIST",
  GET_JOB_LIST: "GET_JOB_LIST",
  TECHNICIAN_LOGS: "TECHNICIAN_LOGS",
  MOTOR_ACTION_LOGS: "MOTOR_ACTION_LOGS",
  GET_INCIDENT_TYPE_LIST: "GET_INCIDENT_TYPE_LIST",
  INCIDENT_FILTER_PARAMETERS: "INCIDENT_FILTER_PARAMETERS",
  TECHNICIAN_TRANSACTION_LIST: "TECHNICIAN_TRANSACTION_LIST",
  GET_STORE_MANAGER_AND_DELIVERY_PERSON_LIST:
    "GET_STORE_MANAGER_AND_DELIVERY_PERSON_LIST",
  CREATE_SETTINGS_TEMPLATE: "CREATE_SETTINGS_TEMPLATE",
  UPDATE_SETTINGS_TEMPLATE: "UPDATE_SETTINGS_TEMPLATE",
  GET_SETTINGS_TEMPLATE_LIST: "GET_SETTINGS_TEMPLATE_LIST",
  GET_SETTINGS_TEMPLATE: "GET_SETTINGS_TEMPLATE",
  DELETE_SETTINGS_TEMPLATE: "DELETE_SETTINGS_TEMPLATE",
  GET_CARRIER_BOARD_LIST: "GET_CARRIER_BOARD_LIST",
  GET_VM_BRAND_MODEL_LIST: "GET_VM_BRAND_MODEL_LIST",
  GET_VM_TYPE_LIST: "GET_VM_TYPE_LIST",
  GET_NETWORK_DEVICE_TYPE_LIST: "GET_NETWORK_DEVICE_TYPE_LIST",
  UNLOCK_VM: "UNLOCK_VM",
  GET_TRANSACTION_REPORT_COLUMNS: "GET_TRANSACTION_REPORT_COLUMNS",
  GET_USER_SAVED_COLUMNS: "GET_USER_SAVED_COLUMNS",
  BLOCK_UNBLOCK_VM_COLUMN: "BLOCK_UNBLOCK_VM_COLUMN",
  GET_FINANCE_REPORT: "GET_FINANCE_REPORT",
  GET_REFUND_REASON_LIST: "GET_REFUND_REASON_LIST",
  GET_REFUNDABLE_ITEMS_LIST: "GET_REFUNDABLE_ITEMS_LIST",
  INITIATE_REFUND: "INITIATE_REFUND",
  GET_USER_LIST: "GET_USER_LIST",
  DELETE_USER: "DELETE_USER",
  FRANCHISE_LIST: "FRANCHISE_LIST",
  USER_ROLES: "USER_ROLES",
  GET_PRODUCT: "GET_PRODUCT",
  DELETE_PRODUCT_CATAGORY: "DELETE_PRODUCT_CATAGORY",
  DELETE_BRAND: "DELETE_BRAND",
  DELETE_PRODUCT_UNIT: "DELETE_PRODUCT_UNIT",
  DELETE_PRODUCT_PACKAGING: "DELETE_PRODUCT_PACKAGING",
  DELETE_WAREHOUSE: "DELETE_WAREHOUSE",
  DELETE_ZONES: "DELETE_ZONES",
  LIST_DELIVERY_PARTNERS: "LIST_DELIVERY_PARTNERS",
  DELETE_DELIVERY_PARTNER: "DELETE_DELIVERY_PARTNER",
  DELETE_FRANCHISE: "DELETE_FRANCHISE",
  DELETE_STORE: "DELETE_STORE",
  GET_COUNTRIES_LIST: "GET_COUNTRIES_LIST",
  GET_STATES_LIST: "GET_STATES_LIST",
  GET_STATE_LIST_BY_COUNTRY: "GET_STATE_LIST_BY_COUNTRY",
  GET_STORE_LIST: "GET_STORE_LIST",
  GET_STATE: "GET_STATE",
  SHIPPING_LIST: "SHIPPING_LIST",
  DELETE_SHIPPING: "DELETE_SHIPPING",
  DELETE_DELIVERY_PERSON: "DELETE_DELIVERY_PERSON",
  DELETE_REFILL_PARTNER: "DELETE_REFILL_PARTNER",
  CHANGE_STATUS_REFILL_PARTNER: "CHANGE_STATUS_REFILL_PARTNER",
  CHANGE_PIN_REFILL_PARTNER: "CHANGE_PIN_REFILL_PARTNER",
  GET_VENDING_MACHINE_LIST: "GET_VENDING_MACHINE_LIST",
  GET_VENDING_MACHINE_CONFIGURED_LIST: "GET_VENDING_MACHINE_CONFIGURED_LIST",
  UPDATE_VM_STATUS: "UPDATE_VM_STATUS",
  DELETE_VM: "DELETE_VM",
  ORDER_LIST: "ORDER_LIST",
  LIST_APPLICABLE_STATES: "LIST_APPLICABLE_STATES",
  LIST_APPLICABLE_CITIES: "LIST_APPLICABLE_CITIES",
  LIST_DISCOUNT: "LIST_DISCOUNT",
  CHANGE_STATUS_CAMPAIGN_OFFER: "CHANGE_STATUS_CAMPAIGN_OFFER",
  GET_DISCOUNT: "GET_DISCOUNT",
  GET_CUPOUPONS_LIST: "GET_CUPOUPONS_LIST",
  PLANOGRAM_LIST: "PLANOGRAM_LIST",
  VENDING_MACHINE_TAGS: "VENDING_MACHINE_TAGS",
  CREATE_PLANOGRAM_TEMPLATE: "CREATE_PLANOGRAM_TEMPLATE",
  GET_PLANOGRAM_TEMPLATE: "GET_PLANOGRAM_TEMPLATE",
  DELETE_PLANOGRAM: "DELETE_PLANOGRA",
  GET_RETURN_ORDER: "GET_RETURN_ORDER",
  GET_MATERIAL_TRANSFER: "GET_MATERIAL_TRANSFER",
  GET_SALE_ORDER: "GET_SALE_ORDER",
  GET_REQUEST_ORDER: "GET_REQUEST_ORDER",
  GET_DISCARD_BIN: "GET_DISCARD_BIN",
  GET_AVAILABLE_PRODUCT: "GET_AVAILABLE_PRODUCT",
  GET_HARDWARE_BOARD_LIST: "GET_HARDWARE_BOARD_LIST",
  DELETE_HARDWARE: "DELETE_HARDWARE",
  VM_MAINTENANCE: "VM_MAINTENANCE",
  DELETED_VM_LIST: "DELETED_VM_LIST",
  RESTART_VM: "RESTART_VM",
  DISABLE_VENDING_MACHINE: "DISABLE_VENDING_MACHINE",
  ENABLE_VENDING_MACHINE: "ENABLE_VENDING_MACHINE",
  LIST_REFILLS: "LIST_REFILLS",
  LIST_RETURN_ORDERS: "LIST_RETURN_ORDERS",
  DELETE_REFILL: "DELETE_REFILL",
  DELETE_RETURN_ORDER: "DELETE_RETURN_ORDER",
  GET_REFILL: "GET_REFILL",
  GET_TOPUP: "GET_TOPUP",
  GET_STORE_RETURN_ORDER_LIST: "GET_STORE_RETURN_ORDER_LIST",
  LIST_STORE_RETURN_ORDERS: "LIST_STORE_RETURN_ORDERS",
  GET_STORE_RETURN_ORDERS: "GET_STORE_RETURN_ORDERS",
  DELETE_STORE_RETURN_ORDERS: "DELETE_STORE_RETURN_ORDERS",
  STORE_STORE_RETURN_ORDER_OVERVIEW: "STORE_STORE_RETURN_ORDER_OVERVIEW",
  GET_BRAND_LIST: "GET_BRAND_LIST",
  GET_REPORT_LIST: "GET_REPORT_LIST",
  GET_REFILL_PARAMETERS: "GET_REFILL_PARAMETERS",
  ADD_RETAILER: "ADD_RETAILER",
  GET_RETAILER_LIST: "GET_RETAILER_LIST",
  UPDATE_RETAILER: "UPDATE_RETAILER",
  DELETE_RETAILER: "DELETE_RETAILER",
  GET_RETAILER: "GET_RETAILER",
  WAREHOUSE_STOCK_LIST: "WAREHOUSE_STOCK_LIST",
  LIST_INVENTORY: "LIST_INVENTORY",
  GET_WAREHOUSE: "GET_WAREHOUSE",
  LIST_PARAMETERS_SHIPPING_CREATE: "LIST_PARAMETERS_SHIPPING_CREATE",
  GET_SHIPPING: "GET_SHIPPING",
  UPDATE_SHIPPING: "UPDATE_SHIPPING",
  GET_FILTER_MODE_PARAMETER: "GET_FILTER_MODE_PARAMETER",
  GET_CASH_ORDER: "GET_CASH_ORDER",
  GET_CASH_ORDER_DETAILS: "GET_CASH_ORDER_DETAILS",
  GET_CUSTOMER_FEEDBACK_LIST: "GET_CUSTOMER_FEEDBACK_LIST",
  GET_ADVERTISEMENT_LIST: "GET_ADVERTISEMENT_LIST",
  DELETE_ADVERTISEMENT: "DELETE_ADVERTISEMENT",
  GET_DAY_DATE_WISE_SALES_DATA: "GET_DAY_DATE_WISE_SALES_DATA",
  GET_HOUR_WISE_SALES_DATA: "GET_HOUR_WISE_SALES_DATA",
  GET_TOP_FAILURE_VM_DATA: "GET_TOP_FAILURE_VM_DATA",
  GET_TOP_SELLING_PRODUCTS: "GET_TOP_SELLING_PRODUCTS",
  GET_TOP_SELLING_BRANDS: "GET_TOP_SELLING_BRANDS",
  GET_VM_PURCHASE_ANALYTICS: "GET_VM_PURCHASE_ANALYTICS",
  GET_REVENUE_VM_DATA: "GET_REVENUE_VM_DATA",
  DOWNLOAD_REFILL_ORDER_REPORT: "DOWNLOAD_REFILL_ORDER_REPORT",
  DOWNLOAD_REQUEST_ORDER_REPORT: "DOWNLOAD_REQUEST_ORDER_REPORT",
  LINK_REFILL_PARTNERS: "LINK_REFILL_PARTNERS",
  EDIT_LINK_REFILL_PARTNERS: "EDIT_LINK_REFILL_PARTNERS",
  EDIT_LINK_WAREHOUSE_MANAGERS: "EDIT_LINK_WAREHOUSE_MANAGERS",
  EDIT_LINK_WAREHOUSE_FOR_WM: "EDIT_LINK_WAREHOUSE_FOR_WM",
  LINK_WAREHOUSE_FOR_WM: "LINK_WAREHOUSE_FOR_WM",
  GET_CUSTOMER_PLATFORM_LIST: "GET_CUSTOMER_PLATFORM_LIST",
  GET_PLATFORM_LINKED_VMList: "GET_PLATFORM_LINKED_VMList",
  GET_RESTRICTED_PRODUCT_LIST: "GET_RESTRICTED_PRODUCT_LIST",
  LINK_VENDING_MACHINES: "LINK_VENDING_MACHINES",
  LINK_VENDING_MACHINES_TECHNICIAN: "LINK_VENDING_MACHINES_TECHNICIAN",
  LINK_WAREHOUSES: "LINK_WAREHOUSES",
  LINK_WAREHOUSES_TECHNICIAN: "LINK_WAREHOUSES_TECHNICIAN",
  LINK_VEHICLES: "LINK_VEHICLES",
  GET_NEGATIVE_ITEMS_LIST: "GET_NEGATIVE_ITEMS_LIST",
  GET_NEGATIVE_ITEM: "GET_NEGATIVE_ITEM",
  DELETE_NEGATIVE_ITEM: "DELETE_NEGATIVE_ITEM",
  LINK_ITEMS: "LINK_ITEMS",
  LINK_VENDING_MACHINES_NEGATIVE_ITEM: "LINK_VENDING_MACHINES_NEGATIVE_ITEM",
  GET_REFILLER_PERMISSIONS: "GET_REFILLER_PERMISSIONS",
  CREATE_REQUEST_PRODUCT: "CREATE_REQUEST_PRODUCT",
  EDIT_REQUEST_PRODUCT: "EDIT_REQUEST_PRODUCT",
  LINK_REFILLER_PERMISSION: "LINK_REFILLER_PERMISSION",
  LINK_REFILLER_NOTIFICATION: "LINK_REFILLER_NOTIFICATION",
  CREATE_KIT_TRANSFER: "CREATE_KIT_TRANSFER",
  GET_CASH_COLLECTION: "GET_CASH_COLLECTION",
  GET_DIRECT_SALES: "GET_DIRECT_SALES",
  GET_LIST_DIRECT_SALES: "GET_LIST_DIRECT_SALES",
  GET_DIRECT_SALES_PARAMETERS: "GET_DIRECT_SALES_PARAMETERS",
  GET_VENDING_MACHINE_NAMES: "GET_VENDING_MACHINE_NAMES",
  GET_ACTIVE_VENDING_MACHINE_RAW_LIST: "GET_ACTIVE_VENDING_MACHINE_RAW_LIST",
  GET_ACTIVE_VENDING_MACHINE_LIST: "GET_ACTIVE_VENDING_MACHINE_LIST",
  GET_ADVERTISEMENT: "GET_ADVERTISEMENT",
  ADD_ADVERTISMENT: "ADD_ADVERTISMENT",
  EDIT_ADVERTISMENT: "EDIT_ADVERTISMENT",
  DELETE_ADVERTISMENT: "DELETE_ADVERTISMENT",
  GET_CASH_IN_HAND_ORDER: "GET_CASH_IN_HAND_ORDER",
  RECEIVE_CASH_IN_HAND_ORDER: "RECEIVE_CASH_IN_HAND_ORDER",
  GET_FRANCHISE_ANALYTICS: "GET_FRANCHISE_ANALYTICS",
  GET_TOP_BRANDS: "GET_TOP_BRANDS",
  GET_RETAILER_ANALYTICS: "GET_RETAILER_ANALYTICS",
  GET_TOP_PRODUCTS: "GET_TOP_PRODUCTS",
  GET_VM_ANALYTICS: "GET_VM_ANALYTICS",
  GET_DELIVERY_PARTNER: "GET_DELIVERY_PARTNER",
  CREATE_DELIVERY_PARTNER: "CREATE_DELIVERY_PARTNER",
  UPDATE_DELIVERY_PARTNER: "UPDATE_DELIVERY_PARTNER",
  GET_DELIVERY_PERSON: "GET_DELIVERY_PERSON",
  CREATE_DELIVERY_PERSON: "CREATE_DELIVERY_PERSON",
  UPDATE_DELIVERY_PERSON: "UPDATE_DELIVERY_PERSON",
  GET_FRANCHISE: "GET_FRANCHISE",
  CREATE_FRANCHISE: "CREATE_FRANCHISE",
  UPDATE_FRANCHISE: "UPDATE_FRANCHISE",
  GET_PRODUCTS_WITH_WH_STOCK_LIST: "GET_PRODUCTS_WITH_WH_STOCK_LIST",
  GET_INVENTORY_LIST: "GET_INVENTORY_LIST",
  GET_UPDATED_INVENTORY_LIST: "GET_UPDATED_INVENTORY_LIST",
  GET_STOCK_AVAILABILITY: "GET_STOCK_AVAILABILITY",
  GET_KIT_TRANSFER: "GET_KIT_TRANSFER",
  GET_VM_PARAMETERS_LIST: "GET_VM_PARAMETERS_LIST",
  GET_LINKABLE_VENDING_MACHINES: "GET_LINKABLE_VENDING_MACHINES",
  CREATE_NEGATIVE_ITEMS: "CREATE_NEGATIVE_ITEMS",
  UPDATE_NEGATIVE_ITEMS: "UPDATE_NEGATIVE_ITEMS",
  GET_NOTIFICATION: "GET_NOTIFICATION",
  GET_NOTIFICATION_LIST: "GET_NOTIFICATION_LIST",
  GET_NOTIFICATION_COUNT: "GET_NOTIFICATION_COUNT",
  CREATE_PRODUCT: "CREATE_PRODUCT",
  UPDATE_PRODUCT: "UPDATE_PRODUCT",
  GET_REQUESTED_PRODUCT: "GET_REQUESTED_PRODUCT",
  GET_PRODUCT_FEEDBACK: "GET_PRODUCT_FEEDBACK",
  GET_PRODUCT_REQUESTS: "GET_PRODUCT_REQUESTS",
  DELETE_PRODUCT_REQUESTS: "DELETE_PRODUCT_REQUESTS",
  DELETE_PRODUCT: "DELETE_PRODUCT",
  GET_REFILL_PARTNERS: "GET_REFILL_PARTNERS",
  GET_LINKABLE_WAREHOUSES: "GET_LINKABLE_WAREHOUSES",
  CREATE_USER: "CREATE_USER",
  UPDATE_USER: "UPDATE_USER",
  GET_USER: "GET_USER",
  CREATE_VENDING_MACHINE: "CREATE_VENDING_MACHINE",
  GET_DELETED_VENDING_MACHINE: "GET_DELETED_VENDING_MACHINE",
  GET_VENDING_MACHINE_FEEDBACK: "GET_VENDING_MACHINE_FEEDBACK",
  ADD_REFILL_PARTNERS: "ADD_REFILL_PARTNERS",
  CREATE_REFILL_PARTNERS: "CREATE_REFILL_PARTNERS",
  UPDATE_REFILL_PARTNERS: "UPDATE_REFILL_PARTNERS",
  ADD_TECHNICIAN_PARTNERS: "ADD_TECHNICIAN_PARTNERS",
  CREATE_TECHNICIAN_PARTNERS: "CREATE_TECHNICIAN_PARTNERS",
  UPDATE_TECHNICIAN_PARTNERS: "UPDATE_TECHNICIAN_PARTNERS",
  GET_TECHNICIAN_PARTNER: "GET_TECHNICIAN_PARTNER",
  CREATE_WAREHOUSES: "CREATE_WAREHOUSES",
  UPDATE_WAREHOUSES: "UPDATE_WAREHOUSES",
  GET_ADMINS_LIST: "GET_ADMINS_LIST",
  GET_VM_TEMPLATE_MODELS: "GET_VM_TEMPLATE_MODELS",
  GET_MANUFACTURERS: "GET_MANUFACTURERS",
  GET_REFILL_PARTNERS_LIST: "GET_REFILL_PARTNERS_LIST",
  GET_REFILL_PARTNERS_VENDING_MACHINE: "GET_REFILL_PARTNERS_VENDING_MACHINE",
  GET_PURCHASE_RETURN_LIST: "GET_PURCHASE_RETURN_LIST",
  EDIT_MATERIAL_TRANSFER: "EDIT_MATERIAL_TRANSFER",
  GET_ALL_REPORT_LIST: "GET_ALL_REPORT_LIST",
  GET_REPORT: "GET_REPORT",
  GET_LIST_OF_MASTER_CONFIG: "GET_LIST_OF_MASTER_CONFIG",
  GENERATE_REPORT: "GENERATE_REPORT",
};

//End points of the api.
export const API_ENDPOINTS = {
  GET_LIST_OF_MASTER_CONFIG: "/master-management",
  GET_VM_LIST_BY_HARDWARE_BOARD: "/vending-machine-management",
  GET_VM_LIST_BY_PLANOGRAM: "/vending-machine-management",
  GET_PLANOGRAM_LIST_BY_VM_TEMPLATE: "/template-management",
  CHANGE_MULTIPLE_TEMPLATE: "/vending-machine-management",
  ISSUE_REPORTER: "/issue-reporter",
  ZONE_MANAGEMENT: "/zone-management",
  WAREHOUSE_MANAGEMENT: "/warehouse-management",
  VM_MANAGEMENT: "/vending-machine-management",
  TEMPLATE_MANAGEMENT: "/template-management",
  INVENTORY_MANAGEMENT: "/inventory-management",
  SALES_ANALYTICS: "/analytics",
  PRODUCT_MANAGEMENT: "/product-management",
  SALES_MANAGEMENT: "/sales",
  PURCHASE_ORDER_MANAGEMENT: "/procurement-management",
  SUPPLIER_MANAGEMENT: "/procurement-management",
  DELIVERY_MANAGEMENT: "/delivery-management",
  FRANCHISE_MANAGEMENT: "/franchise-management",
  REFILL_MANAGEMENT: "/refill-management",
  USER_MANAGEMENT: "/user-management",
  SHIPPING_MANAGEMENT: "/shipping-management",
  OFFER_MANAGEMENT: "/offers-management",
  LIST_STORE_RETURN_ORDERS: "/shipping-management",
  RETAILER_MANAGEMENT: "/retailer-management",
  WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM: "/warehouse-inventory-management",
  ADVERTISEMENT_MANAGEMENT: "/advertisement-management",
  CUSTOMER_PLATFORM: "/campaign-management",
  NOTIFICATION_SERVICE: "/notification-service",
  REPORT_LIST: "/vending-machine-management",
  LIST_REPORT: "/report-management",
};

//Particular end-points of api calls
export const API_ROUTES = {
  [API_ROUTES_KEY.GET_LIST_OF_MASTER_CONFIG]:
    API_ENDPOINTS.GET_LIST_OF_MASTER_CONFIG,
  [API_ROUTES_KEY.GET_CASH_ORDER]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.GET_CASH_ORDER_DETAILS]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.GET_TALLY_ORDER]: API_ENDPOINTS.REFILL_MANAGEMENT,

  [API_ROUTES_KEY.CHANGE_SUPPLIER_EMAIL]: [
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  ],
  [API_ROUTES_KEY.RECEIVE_PURCHASE_ORDER]: [
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  ],
  [API_ROUTES_KEY.GET_DISCARD_BIN]: [
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  ],
  [API_ROUTES_KEY.GET_TALLY_INVENTORY]: [
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  ],
  [API_ROUTES_KEY.USER_FILTER_PARAMETERS]: [API_ENDPOINTS.USER_MANAGEMENT],
  [API_ROUTES_KEY.GET_MATERIAL_TRANSFER]: [
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  ],
  [API_ROUTES_KEY.EDIT_MATERIAL_TRANSFER]: [
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  ],
  [API_ROUTES_KEY.WAREHOUSE_FILTER_PARAMETERS]: [
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  ],
  [API_ROUTES_KEY.DELETE_STORE_RETURN_ORDER]: [
    API_ENDPOINTS.SHIPPING_MANAGEMENT,
  ],
  [API_ROUTES_KEY.STORE_STORE_RETURN_ORDER]: [
    API_ENDPOINTS.SHIPPING_MANAGEMENT,
  ],
  [API_ROUTES_KEY.STORE_STORE_RETURN_ORDER_OVERVIEW]: [
    API_ENDPOINTS.SHIPPING_MANAGEMENT,
  ],
  [API_ROUTES_KEY.EDIT_VENDING_MACHINE]: [
    API_ENDPOINTS.GET_VM_LIST_BY_PLANOGRAM,
  ],

  [API_ROUTES_KEY.VENDING_MACHINE_TAGS]: [
    API_ENDPOINTS.GET_VM_LIST_BY_HARDWARE_BOARD,
  ],

  [API_ROUTES_KEY.LINK_HARDWARE_BOARD]: [
    API_ENDPOINTS.GET_VM_LIST_BY_HARDWARE_BOARD,
  ],
  [API_ROUTES_KEY.GET_VM_LIST_BY_HARDWARE_BOARD]: [
    API_ENDPOINTS.GET_VM_LIST_BY_HARDWARE_BOARD,
  ],
  [API_ROUTES_KEY.GET_VM_LIST_BY_PLANOGRAM]:
    API_ENDPOINTS.GET_VM_LIST_BY_PLANOGRAM,
  [API_ROUTES_KEY.GET_PLANOGRAM_LIST_BY_VM_TEMPLATE]:
    API_ENDPOINTS.GET_PLANOGRAM_LIST_BY_VM_TEMPLATE,
  [API_ROUTES_KEY.CHANGE_MULTIPLE_TEMPLATE]:
    API_ENDPOINTS.CHANGE_MULTIPLE_TEMPLATE,
  [API_ROUTES_KEY.ISSUE_REPORTER]: API_ENDPOINTS.ISSUE_REPORTER,
  [API_ROUTES_KEY.LIST_ZONES]: API_ENDPOINTS.ZONE_MANAGEMENT,
  [API_ROUTES_KEY.LIST_WAREHOUSES]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_WAREHOUSES]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.GET_WAREHOUSE]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.GET_VENDING_MACHINE]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.GET_STORE_INVENTORY]: API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_TALLY_INVENTORY_ORDER]:
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  [API_ROUTES_KEY.GET_WAREHOUSE_INVENTORY]: API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_SAVED_REPORT]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_SAVED_SALES_TEMPLATE]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_SAVED_SALES_REPORT]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_DEFAULT_SALES_TEMPLATE]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.LIST_SHIPPING_WAREHOUSES]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.GET_USER_PRODUCT_CATEGORY_LIST]:
    API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.DOWNLOAD_TRANSACTIONS_HISTORY]:
    API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.GET_SUPPLIER_LIST]: API_ENDPOINTS.SUPPLIER_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_SUPPLIER]: API_ENDPOINTS.SUPPLIER_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_SUPPLIER]: API_ENDPOINTS.SUPPLIER_MANAGEMENT,
  [API_ROUTES_KEY.GET_SUPPLIER]: API_ENDPOINTS.SUPPLIER_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_SUPPLIER]: API_ENDPOINTS.SUPPLIER_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRODUCT_LIST]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_REQUESTED_PRODUCT]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRODUCT_TYPE_LIST]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRODUCT_FEEDBACK]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRODUCT_REQUESTS]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRODUCT]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_PURCHASE_ORDER_LIST]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.GET_PURCHASE_RETURN_LIST]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.GET_PURCHASE_ORDER]: API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_PURCHASE_ORDER]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_PURCHASE_ORDER]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_PURCHASE_ORDER]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.MANAGE_PURCHASE_ORDER]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.GET_WAREHOUSE_LIST]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.GET_SUPPLIER_LIST_BY_PRODUCT_IDS]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRICE_AND_QUANTITY_BY_SUPPLIER]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.GET_COMPANY_INVENTORY_ACTIVE_PRODUCTS]:
    API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.GET_COMPANY_INVENTORY_MAPPED_WITH_SUPPLIERS]:
    API_ENDPOINTS.PURCHASE_ORDER_MANAGEMENT,
  [API_ROUTES_KEY.GET_STORE_INVENTORY_ACTIVE_PRODUCTS]:
    API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_RUNOUT_AND_MAX_QTY]:
    API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.LIST_STORE_AND_WAREHOUSE_INVENTORY]:
    API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.GET_STORE_MANAGER_LIST]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_STORE_MANAGER]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_STORE_LIST]: API_ENDPOINTS.FRANCHISE_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_FRANCHISE]: API_ENDPOINTS.FRANCHISE_MANAGEMENT,
  [API_ROUTES_KEY.GET_STORE_MANAGER]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_STORE_MANAGER]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_STORE_MANAGER]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_REFILL_PARTNERS]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_VM_TEMPLATE_LIST]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_VM_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_VM_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_VM_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_VM_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_STORE_MANAGER_BY_STORE_ID]:
    API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_BULK_REFILL_LIST]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.GET_BULK_REFILL]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_BULK_REFILL]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_BULK_REFILL]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_BULK_REFILL]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_REFILL]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_REFILL]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.ASSIGN_DP_TO_REFILL_IN_BULK_REFILL]:
    API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.GET_DELIVERY_PERSON_LIST]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_DELIVERY_PERSON]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_REFILL_PARTNER_LIST]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.LIST_DELIVERY_PARTNERS]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_DELIVERY_PARTNER]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_TECHNICIAN_PARTNER_LIST]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_TECHNICIAN_PARTNERS]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_TECHNICIAN_PARTNER]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_INCIDENT_LIST]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_INCIDENT_TYPE_LIST]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.INCIDENT_FILTER_PARAMETERS]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_JOB_LIST]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_STORE_MANAGER_AND_DELIVERY_PERSON_LIST]:
    API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_SETTINGS_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_SETTINGS_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_SETTINGS_TEMPLATE_LIST]:
    API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_SETTINGS_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_SETTINGS_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_CARRIER_BOARD_LIST]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_VM_BRAND_MODEL_LIST]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_VM_TYPE_LIST]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_NETWORK_DEVICE_TYPE_LIST]:
    API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.UNLOCK_VM]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.GET_TRANSACTION_REPORT_COLUMNS]:
    API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.GET_USER_SAVED_COLUMNS]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.BLOCK_UNBLOCK_VM_COLUMN]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.GET_FINANCE_REPORT]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_REFUND_REASON_LIST]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.GET_REFUNDABLE_ITEMS_LIST]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.INITIATE_REFUND]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.GET_USER_LIST]: API_ENDPOINTS.USER_MANAGEMENT,
  [API_ROUTES_KEY.GET_USER]: API_ENDPOINTS.USER_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_USER]: API_ENDPOINTS.USER_MANAGEMENT,
  [API_ROUTES_KEY.FRANCHISE_LIST]: API_ENDPOINTS.FRANCHISE_MANAGEMENT,
  [API_ROUTES_KEY.USER_ROLES]: API_ENDPOINTS.USER_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRODUCT_BRAND_LIST]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.LIST_DS1_BRANDS]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.LIST_DS1_PRODUCT_CATALOGUES]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.LIST_DS1_PRODUCTS_BY_CATALOGUE]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_DS1_PRODUCT_FILTERS]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.SYNC_DS1_PRODUCTS]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.LIST_DS1_ALL_PRODUCTS]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_DS1_ALL_PRODUCT_FILTERS]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_DS1_PRODUCT_VARIANT_OVERVIEW]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.ARCHIVE_DS1_PRODUCT_VARIANT]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.SYNC_DS1_FULL_CATALOGUE]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_BRAND]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRODUCT_UNIT_LIST]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_PRODUCT_PACKAGING_LIST]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_PRODUCT]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_PRODUCT_PACKAGING]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_DELIVERY_PARTNER]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_STORE]: API_ENDPOINTS.FRANCHISE_MANAGEMENT,
  [API_ROUTES_KEY.GET_COUNTRIES_LIST]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.GET_STATE_LIST_BY_COUNTRY]:
    API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.GET_STATES_LIST]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.GET_STORE]: API_ENDPOINTS.FRANCHISE_MANAGEMENT,
  [API_ROUTES_KEY.GET_STATE]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.SHIPPING_LIST]: API_ENDPOINTS.SHIPPING_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_SHIPPING]: API_ENDPOINTS.SHIPPING_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_DELIVERY_PERSON]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_VENDING_MACHINE_LIST]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.GET_VENDING_MACHINE_CONFIGURED_LIST]:
    API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.GET_REFILL_PARTNERS_VENDING_MACHINE]:
    API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_VM_STATUS]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.GET_DELETED_VENDING_MACHINE]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.GET_VENDING_MACHINE_FEEDBACK]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_VM]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.ORDER_LIST]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.LIST_APPLICABLE_STATES]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.LIST_APPLICABLE_CITIES]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.LIST_DISCOUNT]: API_ENDPOINTS.OFFER_MANAGEMENT,
  [API_ROUTES_KEY.GET_DISCOUNT]: API_ENDPOINTS.OFFER_MANAGEMENT,
  [API_ROUTES_KEY.GET_CUPOUPONS_LIST]: API_ENDPOINTS.OFFER_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_PLANOGRAM_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.PLANOGRAM_LIST]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_PLANOGRAM_TEMPLATE]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_PLANOGRAM]: API_ENDPOINTS.TEMPLATE_MANAGEMENT,
  [API_ROUTES_KEY.GET_RETURN_ORDER]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.GET_AVAILABLE_PRODUCT]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_HARDWARE_BOARD_LIST]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.VM_MAINTENANCE]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.DELETED_VM_LIST]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.RESTART_VM]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.GET_VENDING_MACHINE]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.DISABLE_VENDING_MACHINE]: API_ENDPOINTS.VM_MANAGEMENT,
  [API_ROUTES_KEY.LIST_REFILLS]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.GET_REFILL]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.GET_TOPUP]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_REFILL]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.LIST_STORE_RETURN_ORDERS]:
    API_ENDPOINTS.LIST_STORE_RETURN_ORDERS,
  [API_ROUTES_KEY.GET_STORE_RETURN_ORDERS]:
    API_ENDPOINTS.LIST_STORE_RETURN_ORDERS,
  [API_ROUTES_KEY.DELETE_STORE_RETURN_ORDERS]:
    API_ENDPOINTS.LIST_STORE_RETURN_ORDERS,
  [API_ROUTES_KEY.GET_BRAND_LIST]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_REPORT_LIST]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.GET_REFILL_PARAMETERS]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.RECEIVE_VM_RETURN_ORDER]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.ADD_RETAILER]: API_ENDPOINTS.RETAILER_MANAGEMENT,
  [API_ROUTES_KEY.ADD_REFILL_PARTNERS]: API_ENDPOINTS.RETAILER_MANAGEMENT,
  [API_ROUTES_KEY.GET_RETAILER_LIST]: API_ENDPOINTS.RETAILER_MANAGEMENT,
  [API_ROUTES_KEY.UPDATE_RETAILER]: API_ENDPOINTS.RETAILER_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_RETAILER]: API_ENDPOINTS.RETAILER_MANAGEMENT,
  [API_ROUTES_KEY.GET_RETAILER]: API_ENDPOINTS.RETAILER_MANAGEMENT,
  [API_ROUTES_KEY.WAREHOUSE_STOCK_LIST]: API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.WAREHOUSES_ORDERS_LIST]:
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  [API_ROUTES_KEY.GET_TALLY_INVENTORY_CATEGORY_LIST]:
    API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.GET_TALLY_INVENTORY_BRAND_LIST]:
    API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.GET_FILTER_MODE_PARAMETER]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.GET_CUSTOMER_FEEDBACK_LIST]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.DOWNLOAD_FEEDBACK_HISTORY]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.GET_ADVERTISEMENT_LIST]:
    API_ENDPOINTS.ADVERTISEMENT_MANAGEMENT,
  [API_ROUTES_KEY.DELETE_ADVERTISEMENT]: API_ENDPOINTS.ADVERTISEMENT_MANAGEMENT,
  [API_ROUTES_KEY.GET_ADVERTISEMENT]: API_ENDPOINTS.ADVERTISEMENT_MANAGEMENT,
  [API_ROUTES_KEY.ADD_ADVERTISMENT]: API_ENDPOINTS.ADVERTISEMENT_MANAGEMENT,
  [API_ROUTES_KEY.EDIT_ADVERTISMENT]: API_ENDPOINTS.ADVERTISEMENT_MANAGEMENT,
  [API_ROUTES_KEY.GET_DAY_DATE_WISE_SALES_DATA]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_HOUR_WISE_SALES_DATA]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_TOP_FAILURE_VM_DATA]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_TOP_SELLING_PRODUCTS]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_TOP_SELLING_BRANDS]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_REVENUE_VM_DATA]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_FRANCHISE_ANALYTICS]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_TOP_BRANDS]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_RETAILER_ANALYTICS]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_TOP_PRODUCTS]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.GET_VM_ANALYTICS]: API_ENDPOINTS.SALES_ANALYTICS,
  [API_ROUTES_KEY.DOWNLOAD_REFILL_ORDER_REPORT]:
    API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.LINK_REFILL_PARTNERS]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.EDIT_LINK_REFILL_PARTNERS]:
    API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.EDIT_LINK_WAREHOUSE_MANAGERS]:
    API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.EDIT_LINK_WAREHOUSE_FOR_WM]:
    API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.LINK_WAREHOUSE_FOR_WM]: API_ENDPOINTS.USER_MANAGEMENT,
  [API_ROUTES_KEY.GET_CUSTOMER_PLATFORM_LIST]: API_ENDPOINTS.CUSTOMER_PLATFORM,
  [API_ROUTES_KEY.GET_PLATFORM_LINKED_VMList]: API_ENDPOINTS.CUSTOMER_PLATFORM,
  [API_ROUTES_KEY.GET_RESTRICTED_PRODUCT_LIST]: API_ENDPOINTS.CUSTOMER_PLATFORM,
  [API_ROUTES_KEY.LINK_VENDING_MACHINES]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.LINK_VENDING_MACHINES_TECHNICIAN]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.LINK_WAREHOUSES]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.LINK_VEHICLES]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.LINK_WAREHOUSES_TECHNICIAN]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.GET_NEGATIVE_ITEMS_LIST]: API_ENDPOINTS.CUSTOMER_PLATFORM,
  [API_ROUTES_KEY.GET_NEGATIVE_ITEM]: API_ENDPOINTS.CUSTOMER_PLATFORM,
  [API_ROUTES_KEY.LINK_ITEMS]: API_ENDPOINTS.CUSTOMER_PLATFORM,
  [API_ROUTES_KEY.LINK_VENDING_MACHINES_NEGATIVE_ITEM]:
    API_ENDPOINTS.CUSTOMER_PLATFORM,
  [API_ROUTES_KEY.GET_REFILLER_PERMISSIONS]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.EDIT_REQUEST_PRODUCT]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_REQUEST_PRODUCT]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.LINK_REFILLER_PERMISSION]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.LINK_REFILLER_NOTIFICATION]:
    API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_DELIVERY_PARTNER]: API_ENDPOINTS.DELIVERY_MANAGEMENT,
  [API_ROUTES_KEY.CREATE_KIT_TRANSFER]:
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  [API_ROUTES_KEY.GET_VEHICLE_LIST]: API_ENDPOINTS.WAREHOUSE_MANAGEMENT,
  [API_ROUTES_KEY.GET_SALE_ORDER]: API_ENDPOINTS.SALES_MANAGEMENT,
  [API_ROUTES_KEY.GET_REQUEST_ORDER]:
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  [API_ROUTES_KEY.GET_CASH_COLLECTION]:
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  [API_ROUTES_KEY.GET_CASH_COLLECTION]:
    API_ENDPOINTS.WAREHOUSE_INVENTORY_MANAGEMENT_SYSTEM,
  [API_ROUTES_KEY.GET_INVENTORY_LIST]: API_ENDPOINTS.PRODUCT_MANAGEMENT,
  [API_ROUTES_KEY.GET_UPDATED_INVENTORY_LIST]:
    API_ENDPOINTS.INVENTORY_MANAGEMENT,
  [API_ROUTES_KEY.GET_KIT_TRANSFER]: API_ENDPOINTS.REFILL_MANAGEMENT,
  [API_ROUTES_KEY.GET_NOTIFICATION]: API_ENDPOINTS.NOTIFICATION_SERVICE,
  [API_ROUTES_KEY.GET_ALL_REPORT_LIST]: API_ENDPOINTS.REPORT_LIST,
  [API_ROUTES_KEY.GET_REPORT]: API_ENDPOINTS.LIST_REPORT,
  [API_ROUTES_KEY.GENERATE_REPORT]: API_ENDPOINTS.LIST_REPORT,
};
